import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const db = firebase.firestore();

const getNextId = async (collectionName, docName) => {
  const idRef = db.collection(collectionName).doc(docName);
  try {
    const nextId = await db.runTransaction(async (transaction) => {
      const idDoc = await transaction.get(idRef);
      const newId = idDoc.exists ? idDoc.data().lastId + 1 : 1;
      transaction.set(idRef, { lastId: newId });
      return newId;
    });
    return nextId;
  } catch (error) {
    console.error(`Failed to fetch and increment ID for ${docName}:`, error);
    throw new Error(`Failed to generate a new ID for ${docName}.`);
  }
};

export const getNextProjectId = () => getNextId("counters", "projectIds");
export const getNextEstimatePdfId = () =>
  getNextId("counters", "estimatePdfCounter");
export const getNextCompanyId = () => getNextId("counters", "companyIds");
export const getNextContactId = () => getNextId("counters", "contactIds");
export const getNextRateCardId = () => getNextId("counters", "rateCardIds");
export const getNextServiceCardId = () =>
  getNextId("counters", "serviceCardIds");
export const getNextRolesCardId = () => getNextId("counters", "rolesCardIds");
